import React from "react";
import "../../css/ErrorPopup.css";

const ErrorPopup = ({ message, onClose }) => {
  return (
    <div className="error-popup-overlay">
      <div className="error-popup">
        <div className="error-popup-message">{message}</div>
        <button className="error-popup-button" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default ErrorPopup;
